var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":!_vm.app,"value":_vm.value}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color,"size":_vm.size,"width":_vm.width}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }